import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { SettingsNinjaService, NinjaEventLayer, NinjaEventLayerField, NinjaLayerColumnConfig, NinjaDefaultsEventLayerConfig } from '../../../../../common-services/settings-ninja.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppinfoService } from '../../../../../common-services/appinfo.service';
import { AppSettings } from '../../../../../app.settings';
import { ToastrService } from 'ngx-toastr';

export interface ModalNinjaColumnsInput {
	layerName: string
}
export interface ModalNinjaColumnsOutput {
	updated?: boolean;
}

type ColumnHeaderProp = 'colName' | 'visib' | 'seq';
interface ColumnHeader {
	displayName: string;
	prop: ColumnHeaderProp;
}
interface ColumnItem extends NinjaLayerColumnConfig{
	visib: boolean;
	disabled?: boolean;
}

@Component({
	selector: 'app-ninja-columns',
	templateUrl: './ninja-columns.component.html',
	styleUrls: ['./ninja-columns.component.css']
})
export class NinjaColumnsComponent implements OnInit {

	public selectedLayer: NinjaEventLayer;
	public columns: ColumnItem[];

	public headers: ColumnHeader[] = [{
		displayName: 'Field',
		prop: 'colName'
	}, {
		displayName: 'Visible',
		prop: 'visib'
	}, {
		displayName: 'Order',
		prop: 'seq'
	}];

	public hasChanged: boolean;
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: ModalNinjaColumnsInput,
		private dialogRef: MatDialogRef<NinjaColumnsComponent>,
		private elemRef: ElementRef,
		private toastr: ToastrService,
		private appinfoService: AppinfoService,
		private ninjaService: SettingsNinjaService
	) { }

	public onToggleColumnVisib(col: ColumnItem) {
		this.hasChanged = true;
		col.hidden = !col.visib;
	}
	public goDown(idx) {
		this.moveColumnOrder(idx, idx + 1);
	}
	public goUp(idx) {
		this.moveColumnOrder(idx, idx - 1);
	}
	private moveColumnOrder(currentIdx, newIdx) {
		this.hasChanged = true;
		if (currentIdx >= 0 && currentIdx <= this.columns.length - 1 && newIdx >= 0 && newIdx <= this.columns.length) {
			const col = this.columns[currentIdx];
			this.columns.splice(currentIdx, 1);
			this.columns.splice(newIdx, 0, col);
		}
	}
	public onDragEnd(e: DragEvent, currentIdx) {
		const elements = this.elemRef.nativeElement.querySelectorAll('.column-item-wrapper');
		if (elements && elements.length >= 2 && e.offsetY !== 0) {
			const colHeight = elements[0].getBoundingClientRect().height;
			// The number of columns that the dragged column has passed
			let numOfColPassed: number;
			let newIdx;
			if (e.offsetY < 0) { // Move up
				numOfColPassed = Math.ceil(Math.abs(e.offsetY) / colHeight);
				newIdx = currentIdx - numOfColPassed;
				if (newIdx < 0) {
					newIdx = 0;
				}
			} else if (e.offsetY > 0) { // Move down
				numOfColPassed = Math.floor(Math.abs(e.offsetY) / colHeight);
				newIdx = currentIdx + numOfColPassed;
				if (newIdx > this.columns.length - 1) {
					newIdx = this.columns.length - 1;
				}
			}
			if (numOfColPassed === 0) {
				return;
			}
			// Move
			this.moveColumnOrder(currentIdx, newIdx);
		}
	}

	public cancel() {
		this.dialogRef.close();
	}
	public async apply() {
		try {
			const defaults = this.ninjaService.ninjaDefaults || {};
			defaults.eventLayers = defaults.eventLayers || {};
			const layerConfig = defaults.eventLayers[this.data.layerName];
			const updatedLayerConfig: NinjaDefaultsEventLayerConfig = {
				systemColumns: layerConfig ? layerConfig.systemColumns : null,
				columns: this.columns.map((col, idx) => {
					return {
						name: col.name,
						seq: idx + 1,
						hidden: col.hidden
					}
				})
			}
			defaults.eventLayers[this.data.layerName] = updatedLayerConfig;
			await this.appinfoService.updateDefaultValue(defaults, AppSettings.ninjaAppName);
			const info = await this.appinfoService.getCustomerAppInfoNinja();
			this.ninjaService.ninjaDefaults = info.defaults;
			this.toastr.success('Successfully updated.');
			this.dialogRef.close();
		} catch (err) {
			console.log(err);
			this.toastr.error('Update failed.');
		}
	}
	ngOnInit() {
		this.selectedLayer = this.ninjaService.eventLayers.find(l => l.name === this.data.layerName);
		if (this.selectedLayer) {
			const columns: ColumnItem[] = [];
			this.selectedLayer.fields.forEach(c => {
				const col: ColumnItem = {
					name: c.name,
					visib: true
				};
				if (c.type === 'esriFieldTypeGeometry') {
					col.visib = false;
					col.disabled = true;
				}
				columns.push(col);
			});
			// Read from config
			const defaults = this.ninjaService.ninjaDefaults || {};
			const layerConfig = defaults.eventLayers ? defaults.eventLayers[this.data.layerName] : null;
			if (layerConfig && layerConfig.columns) {
				layerConfig.columns.forEach(config => {
					const column = columns.find(col => col.name === config.name);
					if (column) {
						column.visib = !config.hidden;
						column.hidden = config.hidden;
						column.seq = config.seq;
					}
				});
			}
			// Sort according to sequence
			columns.sort((a, b) => {
				if (a.seq && b.seq) {
					if (a.seq < b.seq) {
						return -1;
					} else if (a.seq > b.seq) {
						return 1;
					} else {
						return 0;
					}
				} else if (!a.seq && !b.seq) {
					return 0;
				} else if (!b.seq) {
					return -1;
				} else if (!a.seq) {
					return 1;
				}
			});
			this.columns = columns;
		} else {
			this.columns = [];
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/settings-ninja/ninja-layers/ninja-columns/ninja-columns.component.ts